import tailwindColors from 'tailwindcss/colors'

import { tenantPalettes } from './tenant-palettes'

export const tenant = 'aos' as const

export const tenantColors = tenantPalettes.aos

// tailwindColors stays spread so existing colors['blue'][500] call sites resolve.
export const colors = { ...tailwindColors, ...tenantColors }
